/**
 * Declare here the Interface and typings for RACE-SESSION entity
 * Remember: ALL changes to these TYPINGS should be done in livedata-motorsports-widgets/src/typings/race-session.ts file, too!
 */
const FREE_PRACTICE_ONE: RaceSessionType = 'FP1';
const FREE_PRACTICE_TWO: RaceSessionType = 'FP2';
const FREE_PRACTICE_THREE: RaceSessionType = 'FP3';
const FREE_PRACTICE_FOUR: RaceSessionType = 'FP4';
const QUALIFYING_GROUP: RaceSessionType = 'Q';
const QUALIFYING_ONE: RaceSessionType = 'Q1';
const QUALIFYING_TWO: RaceSessionType = 'Q2';
const QUALIFYING_THREE: RaceSessionType = 'Q3';
const QUALIFYING_SPRINT: RaceSessionType = 'QS';
const RACE_SPRINT: RaceSessionType = 'SPRINT';
const RACE: RaceSessionType = 'R';
const RACE_ONE: RaceSessionType = 'R1';
const RACE_TWO: RaceSessionType = 'R2';
const SHOOTOUT_SPRINT_GROUP: RaceSessionType = 'SS';
const SHOOTOUT_SPRINT_ONE: RaceSessionType = 'SS1';
const SHOOTOUT_SPRINT_TWO: RaceSessionType = 'SS2';
const SHOOTOUT_SPRINT_THREE: RaceSessionType = 'SS3';
const STARTING_GRID_SPRINT: RaceSessionType = 'GS';
const STARTING_GRID: RaceSessionType = 'G';
const WARMUP: RaceSessionType = 'W';

const RACE_STATUS_FIXTURE: RaceSessionStatus = 'Fixture';
const RACE_STATUS_PLAYING: RaceSessionStatus = 'Playing';
const RACE_STATUS_PLAYED: RaceSessionStatus = 'Played';
const RACE_STATUS_CANCELLED: RaceSessionStatus = 'Cancelled';
const RACE_STATUS_POSTPONED: RaceSessionStatus = 'Postponed';
const RACE_STATUS_SUSPENDED: RaceSessionStatus = 'Suspended';

export type RaceSessionType =
  | 'FP1'
  | 'FP2'
  | 'FP3'
  | 'FP4'
  | 'G'
  | 'GS'
  | 'Q'
  | 'Q1'
  | 'Q2'
  | 'Q3'
  | 'QS'
  | 'R'
  | 'R1'
  | 'R2'
  | 'SPRINT'
  | 'SS'
  | 'SS1'
  | 'SS2'
  | 'SS3'
  | 'W';

export type RaceSessionStatus = 'Fixture' | 'Playing' | 'Played' | 'Cancelled' | 'Postponed' | 'Suspended';

export const freePractices: RaceSessionType[] = [
  FREE_PRACTICE_ONE,
  FREE_PRACTICE_TWO,
  FREE_PRACTICE_THREE,
  FREE_PRACTICE_FOUR,
];

// Used by DS only (not in WIDGET project)
export const raceSessionTypeList: RaceSessionType[] = [
  FREE_PRACTICE_FOUR,
  FREE_PRACTICE_ONE,
  FREE_PRACTICE_THREE,
  FREE_PRACTICE_TWO,
  QUALIFYING_GROUP,
  QUALIFYING_ONE,
  QUALIFYING_SPRINT,
  QUALIFYING_THREE,
  QUALIFYING_TWO,
  RACE_ONE,
  RACE_SPRINT,
  RACE_TWO,
  RACE,
  SHOOTOUT_SPRINT_GROUP,
  SHOOTOUT_SPRINT_ONE,
  SHOOTOUT_SPRINT_THREE,
  SHOOTOUT_SPRINT_TWO,
  STARTING_GRID_SPRINT,
  STARTING_GRID,
  WARMUP,
];

export const raceSessionStatusList: RaceSessionStatus[] = [
  RACE_STATUS_FIXTURE,
  RACE_STATUS_PLAYING,
  RACE_STATUS_PLAYED,
  RACE_STATUS_CANCELLED,
  RACE_STATUS_POSTPONED,
  RACE_STATUS_SUSPENDED,
];

export {
  FREE_PRACTICE_ONE,
  FREE_PRACTICE_TWO,
  FREE_PRACTICE_THREE,
  FREE_PRACTICE_FOUR,
  QUALIFYING_ONE,
  QUALIFYING_TWO,
  QUALIFYING_THREE,
  QUALIFYING_GROUP,
  STARTING_GRID,
  WARMUP,
  RACE,
  RACE_ONE,
  RACE_TWO,
  RACE_STATUS_FIXTURE,
  RACE_STATUS_PLAYING,
  RACE_STATUS_PLAYED,
  RACE_STATUS_CANCELLED,
  RACE_STATUS_POSTPONED,
  RACE_STATUS_SUSPENDED,
  // ISS-4730 - SPRINT RACE
  RACE_SPRINT,
  STARTING_GRID_SPRINT,
  QUALIFYING_SPRINT,
  SHOOTOUT_SPRINT_GROUP,
  SHOOTOUT_SPRINT_ONE,
  SHOOTOUT_SPRINT_TWO,
  SHOOTOUT_SPRINT_THREE,
};

export type LgpSession = {
  [k in RaceSessionType]: {
    ssi: string;
    startDateTime: string;
    customDataAttributes: {
      tracking: string;
      url: string;
    } | null;
  };
};
